import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import classNames from "classnames"
import memo from "set-state-compare/build/memo"
import Nav from "components/nav"
import NavItem from "components/nav/item"
import {Plan} from "models"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
import useI18n from "i18n-on-steroids/src/use-i18n.mjs"

export default memo(shapeComponent(class ComponentsPlansNav extends ShapeComponent {
  static propTypes = {
    active: PropTypes.string,
    className: PropTypes.string,
    plan: PropTypes.instanceOf(Plan).isRequired
  }

  render() {
    const {t} = useI18n({namespace: "js.components.admin.plans.nav"})
    const {active, className, plan, ...restProps} = this.props

    return (
      <Nav className={classNames("components--admin--plans--nav", className)} {...restProps}>
        <NavItem active={active} identifier="general" label={t("js.shared.general")} to={Routes.adminPlanPath(plan.id())} />
        <NavItem
          active={active}
          identifier="subscriptions"
          label={Plan.humanAttributeName("subscriptions")}
          to={Routes.subscriptionsAdminPlanPath(plan.id())}
        />
      </Nav>
    )
  }
}))
